import { render, staticRenderFns } from "./TrCanvasToolbox.vue?vue&type=template&id=4b16e9a8&scoped=true&"
import script from "./TrCanvasToolbox.vue?vue&type=script&lang=js&"
export * from "./TrCanvasToolbox.vue?vue&type=script&lang=js&"
import style0 from "./TrCanvasToolbox.vue?vue&type=style&index=0&id=4b16e9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16e9a8",
  null
  
)

export default component.exports